export const DemoDayRankingTranslations = {
  TITLE: {
    es: 'Demo Day - Ranking',
    en: 'Demo Day - Ranking',
    cat: 'Demo Day - Ranking',
    eus: 'Demo Day - Ranking',
    pt: 'Demo Day - Ranking'
  },
  POSITION: {
    es: 'Posición',
    en: 'Position',
    cat: 'Posició',
    eus: 'Posizioa',
    pt: 'Posição'
  },
  PARTICIPANT: {
    es: 'Participante',
    en: 'Participant',
    cat: 'Participant',
    eus: 'Partaidea',
    pt: 'Participante'
  },
  SCORE: {
    es: 'Puntuación',
    en: 'Score',
    cat: 'Puntuació',
    eus: 'Puntuazioa',
    pt: 'Pontuação'
  },
  TESTS: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Testak',
    pt: 'Testes'
  },
  TIME: {
    es: 'Tiempo',
    en: 'Time',
    cat: 'Temps',
    eus: 'Denbora',
    pt: 'Tempo'
  },
  NO_RESULTS: {
    es: 'Aún no hay resultados. ¡Que empiece la competición!',
    en: 'No results yet. Let the competition begin!',
    cat: 'Encara no hi ha resultats. Que comenci la competició!',
    eus: 'Oraindik ez dago emaitzarik. Has dadila lehia!',
    pt: 'Ainda não há resultados. Que comece a competição!'
  },
  TESTS_COMPLETED: {
    es: '{{completed}}/4',
    en: '{{completed}}/4',
    cat: '{{completed}}/4',
    eus: '{{completed}}/4',
    pt: '{{completed}}/4'
  }
};
